var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('Notifications'),_c('vue-confirm-dialog'),_c('link',{attrs:{"href":"https://fonts.googleapis.com/css2?family=Montserrat&display=swap","rel":"stylesheet"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }